import { format, isValid } from 'date-fns';
import { Calendar as CalendarIcon } from 'lucide-react';
import { useRef } from 'react';

import normalizeAnnotationDate from '@/lib/normalizeAnnotationDate';
import { cn } from 'components/lib/utils';

import { Button } from 'components/ui/button';
import { Calendar } from 'components/ui/calendar';
import { Input } from 'components/ui/input';
import { Popover, PopoverContent, PopoverTrigger } from 'components/ui/popover';

export default function DatePickerWithInputField({
  story,
  date,
  setDate,
  onOpenChange,
  onDateSelected,
}) {
  const inputRef = useRef(null);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={'outline'}
          className={cn(
            'justify-start text-left font-normal',
            !date && 'text-muted-foreground'
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {format(date, 'PPP')}
        </Button>
      </PopoverTrigger>

      <PopoverContent
        className="flex w-auto flex-col space-y-2 p-2"
        onOpenAutoFocus={(_e) => onOpenChange(true)}
        onEscapeKeyDown={(_e) => onOpenChange(false)}
        onInteractOutside={(_e) => onOpenChange(false)}
      >
        <Input
          ref={inputRef}
          size={12}
          value={undefined}
          type="text"
          placeholder={format(date, 'y-MM-dd')}
          onKeyDown={(e) => {
            if (e.key !== 'Enter') {
              return;
            }

            const inputDate = normalizeAnnotationDate(
              story,
              new Date(e.currentTarget.value)
            );

            if (!isValid(inputDate)) {
              return;
            }

            setDate(inputDate);

            onDateSelected(inputDate);
          }}
        />

        <Calendar
          className="border-none"
          mode="single"
          defaultMonth={date}
          selected={date}
          onSelect={(date) => {
            setDate(date);

            if (date === null || date === undefined) {
              return;
            }

            const inputDate = normalizeAnnotationDate(story, date);

            onDateSelected(inputDate);
          }}
        />
      </PopoverContent>
    </Popover>
  );
}
